/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ManualSetting
 */
export interface ManualSetting {
    /**
     * 
     * @type {string}
     * @memberof ManualSetting
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ManualSetting
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ManualSetting
     */
    ifapmeSide?: string | null;
}

/**
 * Check if a given object implements the ManualSetting interface.
 */
export function instanceOfManualSetting(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ManualSettingFromJSON(json: any): ManualSetting {
    return ManualSettingFromJSONTyped(json, false);
}

export function ManualSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManualSetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'ifapmeSide': !exists(json, 'ifapmeSide') ? undefined : json['ifapmeSide'],
    };
}

export function ManualSettingToJSON(value?: ManualSetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'url': value.url,
        'ifapmeSide': value.ifapmeSide,
    };
}

